/* Industrialsafety-UK — header drawer + stock finder (1-10-2026). */
(function () {
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* mobile drawer */
  var drawer = $('[data-isu-drawer]'), open = $('[data-isu-open]');
  if (drawer && open) {
    var close = function () { drawer.hidden = true; open.setAttribute('aria-expanded', 'false'); document.documentElement.style.overflow = ''; open.focus(); };
    open.addEventListener('click', function () {
      drawer.hidden = false; open.setAttribute('aria-expanded', 'true'); document.documentElement.style.overflow = 'hidden';
      var c = $('[data-isu-close]', drawer); if (c) c.focus();
    });
    $$('[data-isu-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
    drawer.addEventListener('click', function (e) { if (e.target === drawer) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
  }

  /* stock finder: material -> profile -> link */
  var f = $('[data-isu-finder]');
  if (f) {
    var mats = $$('.isu-mat', f), profs = $$('.isu-prof', f), go = $('[data-isu-go]', f), goLabel = $('[data-isu-go-label]', f), pc = $('[data-isu-pcount]', f);
    var mat = mats.filter(function (m) { return m.getAttribute('aria-pressed') === 'true'; })[0] || mats[0];
    var prof = null;
    var map = function (m) {
      var o = {};
      (m.getAttribute('data-profiles') || '').split(',').forEach(function (pair) {
        var i = pair.indexOf('='); if (i > 0) o[pair.slice(0, i)] = pair.slice(i + 1);
      });
      return o;
    };
    var render = function () {
      var m = map(mat), name = mat.getAttribute('data-name');
      mats.forEach(function (b) { b.setAttribute('aria-pressed', b === mat ? 'true' : 'false'); });
      var avail = 0;
      profs.forEach(function (b) {
        var k = b.getAttribute('data-prof'), ok = !!m[k];
        b.disabled = !ok; if (ok) avail++;
        b.setAttribute('aria-pressed', prof === k ? 'true' : 'false');
      });
      if (pc) pc.textContent = '— ' + avail + ' of ' + profs.length + ' in ' + name.toLowerCase();
      if (prof && m[prof]) {
        var label = profs.filter(function (b) { return b.getAttribute('data-prof') === prof; })[0].getAttribute('data-label');
        go.href = m[prof]; goLabel.textContent = 'Show ' + name + ' ' + label.toLowerCase() + ' sizes';
      } else {
        go.href = mat.getAttribute('data-url'); goLabel.textContent = 'Show all ' + name;
      }
    };
    mats.forEach(function (b) {
      b.addEventListener('click', function () {
        mat = b;
        var m = map(mat); if (prof && !m[prof]) prof = null;
        render();
      });
    });
    profs.forEach(function (b) {
      b.addEventListener('click', function () { if (b.disabled) return; prof = prof === b.getAttribute('data-prof') ? null : b.getAttribute('data-prof'); render(); });
    });
    var m0 = map(mat); if (m0.angle) prof = 'angle';
    render();
  }
})();
